import type { ComponentProps } from "react"
import { HoverCardTrigger as HoverCardTriggerBase } from "@/v2-ui/hoverCard/base/HoverCardBase"
import cn from "@/v2-ui/utils/utils.cn"

export type HoverCardTriggerProps = ComponentProps<typeof HoverCardTriggerBase>

function HoverCardTrigger(props: HoverCardTriggerProps) {
  const { className, ...selectItemBaseProps } = props
  return (
    <HoverCardTriggerBase
      className={cn("ui-hoverCard-trigger", className)}
      {...selectItemBaseProps}
    />
  )
}

export default HoverCardTrigger
